(function () {
  'use strict';

  var P = '[FGS]';
  var DEBUG = false; // set true to trace the free-gift flow in console
  function log()  { if (DEBUG) { var a=[P].concat([].slice.call(arguments)); console.log.apply(console,a); } }
  function warn() { if (DEBUG) { var a=[P].concat([].slice.call(arguments)); console.warn.apply(console,a); } }
  function lerr() { var a=[P].concat([].slice.call(arguments)); console.error.apply(console,a); }

  // ── Variant helpers ────────────────────────────────────────────────────────

  function parseVariants(root) {
    try {
      // The browser already HTML-decodes data attribute values.
      // Never call decodeURIComponent here — it throws on flavor names like "100% Original".
      var raw = root.getAttribute('data-variants') || '[]';
      var v = JSON.parse(raw);
      log('Parsed', v.length, 'variants');
      return v;
    } catch (e) {
      lerr('Failed to parse data-variants JSON:', e);
      return [];
    }
  }

  function resolveVariant(root, variants) {
    var flavorSel   = root.querySelector('#fgs-flavor');
    var nicotineSel = root.querySelector('#fgs-nicotine');
    var flavor      = flavorSel   ? flavorSel.value   : null;
    var nicotine    = nicotineSel ? nicotineSel.value : null;

    log('Resolving — flavor:', JSON.stringify(flavor), '| nicotine:', JSON.stringify(nicotine));

    var match = (variants || []).find(function (v) {
      return (!flavor   || v.option1 === flavor) &&
             (!nicotine || v.option2 === nicotine);
    });

    if (!match) {
      warn('No variant matched. option1 values:', (variants || []).map(function (v) { return v.option1; }));
      return null;
    }
    if (!match.available) {
      warn('Matched variant', match.id, 'is unavailable');
      return null;
    }
    log('Resolved free-gift variant ID:', match.id);
    return match;
  }

  // ── Init: wire selector change listeners ──────────────────────────────────

  function init() {
    var root = document.querySelector('#free-gift-selector');
    if (!root) {
      log('Widget not present — page is not a free-juice-promo product');
      return;
    }
    log('Init on', window.location.pathname);

    var variants    = parseVariants(root);
    var flavorSel   = root.querySelector('#fgs-flavor');
    var nicotineSel = root.querySelector('#fgs-nicotine');
    var unavailMsg  = root.querySelector('.fgs__unavailable');

    function updateState() {
      var match = resolveVariant(root, variants);
      root.dataset.selectedVariant = match ? String(match.id) : '';
      log('data-selected-variant ->', root.dataset.selectedVariant || '(unavailable)');
      if (unavailMsg) unavailMsg.style.display = match ? 'none' : 'block';
    }

    if (flavorSel)   flavorSel.addEventListener('change', updateState);
    if (nicotineSel) nicotineSel.addEventListener('change', updateState);
    updateState();
    log('Ready. Initial variant:', root.dataset.selectedVariant);
  }

  // ── ATC interceptor ───────────────────────────────────────────────────────

  var _busy = false;

  function fallback(form) {
    lerr('Falling back to normal ATC — only the device will be added to cart');
    window.removeEventListener('submit', interceptor, true);
    if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); }
    setTimeout(function () { window.addEventListener('submit', interceptor, true); }, 600);
  }

  function interceptor(e) {
    var pfc = e.target && typeof e.target.closest === 'function'
      ? e.target.closest('product-form-component')
      : null;
    if (!pfc) return;

    log('submit intercepted on product-form-component');

    var root = document.querySelector('#free-gift-selector');
    if (!root) {
      log('Widget absent — normal ATC');
      return;
    }

    if (_busy) {
      warn('Duplicate submit ignored (request in-flight)');
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }

    // Re-derive at submit time so stale dataset from section re-renders is not used
    var variants = parseVariants(root);
    var match    = resolveVariant(root, variants);
    root.dataset.selectedVariant = match ? String(match.id) : '';
    var promoId = root.dataset.selectedVariant;

    if (!promoId) {
      warn('No available free-gift variant — allowing normal ATC (device only)');
      return;
    }

    e.preventDefault();
    e.stopImmediatePropagation();
    _busy = true;

    var form  = e.target;
    var fd    = new FormData(form);
    var devId = String(fd.get('id') || '');
    var qty   = Math.max(1, parseInt(String(fd.get('quantity') || '1'), 10) || 1);
    var props = {};
    fd.forEach(function (val, key) {
      if (key.startsWith('properties[')) props[key.slice(11, -1)] = String(val);
    });

    if (!devId) {
      lerr('Could not read device variant ID from form');
      _busy = false;
      fallback(form);
      return;
    }

    log('Device variant:', devId, '| qty:', qty, '| props:', props);
    log('Free-gift variant:', promoId);

    var atcEl = pfc.querySelector('add-to-cart-component');
    var btn   = atcEl ? atcEl.querySelector('[ref=addToCartButton]') : form.querySelector('[type=submit]');
    if (btn) btn.disabled = true;

    var sectionIds = [];
    document.querySelectorAll('[data-section-id]').forEach(function (el) {
      var sid = el.dataset.sectionId;
      if (sid && sectionIds.indexOf(sid) === -1) sectionIds.push(sid);
    });
    log('Section IDs for refresh:', sectionIds);

    var payload = {
      items: [
        { id: Number(devId),   quantity: qty, properties: props },
        { id: Number(promoId), quantity: 1,   properties: { _gift: 'free-juice-promo' } },
      ],
    };
    if (sectionIds.length) payload.sections = sectionIds.join(',');

    log('POST /cart/add.js with', payload.items.length, 'items:', payload);

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body:    JSON.stringify(payload),
    })
      .then(function (r) {
        log('Response HTTP', r.status);
        return r.json();
      })
      .then(function (resp) {
        log('Response body:', resp);
        // Shopify error responses have a numeric status field (e.g. 422)
        if (resp.status) {
          throw new Error('[' + resp.status + '] ' + (resp.description || resp.message || 'Cart error'));
        }
        var addedIds = (resp.items || []).map(function (i) { return i.variant_id; });
        log('Cart add OK. Added variant IDs:', addedIds);

        // Signal Horizon cart drawer via its expected custom event
        pfc.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: {},
            sourceId: String(devId),
            data: {
              source:    'product-form-component',
              itemCount: qty + 1,
              productId: pfc.dataset.productId || '',
              sections:  resp.sections || {},
            },
          },
        }));
        log('cart:update event dispatched on product-form-component');

        // Belt-and-suspenders: also try calling drawer.open() directly
        var drawer = document.querySelector('cart-drawer-component');
        if (drawer && typeof drawer.open === 'function') {
          setTimeout(function () {
            log('Calling cart-drawer-component.open()');
            drawer.open();
          }, 80);
        }
      })
      .catch(function (e2) {
        lerr('Cart add request failed:', e2);
        fallback(form);
      })
      .finally(function () {
        _busy = false;
        if (btn) btn.disabled = false;
      });
  }

  // Register capture-phase interceptor immediately — this runs synchronously
  // the moment the script tag is parsed, before the rest of the page loads.
  window.addEventListener('submit', interceptor, true);
  log('Interceptor registered on window (capture phase)');

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
